module.exports = __webpack_public_path__ + "static/media/loading-green.a57b37f0.svg";